module.exports = __webpack_public_path__ + "img/media_logo_dark.07864e05.png";